export enum APISortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export enum APIStringifiedBoolean {
  TRUE = 'true',
  FALSE = 'false',
}
